import React from "react";
import { DumontLogo } from "../../../../Generic/Icons";
import {
  MessageContainer,
  IconContainer,
  ContentContainer,
  InnerContent,
  HeaderText,
  OrderContainer,
  OrderText,
  OrderDetailsContainer,
  ViewDetailsLink,
  FooterText,
} from "./styled";

interface DispatchOrder {
  orderNumber: string;
  date: string;
  time: string;
}

interface MessageDumontDispatchProps {
  orders: DispatchOrder[];
}

export default function MessageDumontDispatch({ orders }: MessageDumontDispatchProps) {
  return (
    <MessageContainer>
      <IconContainer>
        <DumontLogo size={16} />
      </IconContainer>

      <ContentContainer>
        <InnerContent>
          <HeaderText>
            I've found {orders.length} orders scheduled for dispatch today. Here's a breakdown:
          </HeaderText>

          {orders.map((order, index) => (
            <OrderContainer key={index}>
              <OrderText>
                🚚 Order #{order.orderNumber} - Scheduled dispatch: {order.date} – {order.time}
              </OrderText>
              <OrderDetailsContainer>
                <ViewDetailsLink>👉 View details</ViewDetailsLink>
              </OrderDetailsContainer>
            </OrderContainer>
          ))}

          <FooterText>Would you like more details on any specific order?</FooterText>
        </InnerContent>
      </ContentContainer>
    </MessageContainer>
  );
}
